var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67438 5.42381L12.7207 9.47009C13.0931 9.84254 13.0931 10.4464 12.7207 10.8188C12.3482 11.1913 11.7444 11.1913 11.3719 10.8188L8 7.44695L4.6281 10.8189C4.25565 11.1913 3.65179 11.1913 3.27934 10.8189C2.90689 10.4464 2.90689 9.84254 3.27934 9.47009L7.32333 5.4261L7.32562 5.4238C7.69807 5.05135 8.30193 5.05136 8.67438 5.42381Z",
    fill: "#002240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.5d12c6063858e041f0af1b2921d5f824.svg";
export { ForwardRef as ReactComponent };